module.exports = __webpack_public_path__ + "1226205e54dd1415c35c3dc5af22fe4f.MP3";